module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_9016.4b801376.png";